<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Signup Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item active">Signup Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <form @submit.prevent="filterData">
                    <div class="d-flex justify-content-center mt-2 mb-2">
                        <div class="col-xl-4 col-md-4">
                            <label>Start date</label><br/>
                            <input type="date" v-model="reportFilter.start_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>End date</label><br/>
                            <input type="date" v-model="reportFilter.end_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>&nbsp;</label><br/>
                            <button type="submit" class="btn btn-primary">Filter</button>
                            <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                        </div>
                    </div>
                </form>
                <div class="card-body">
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <!--                        <download-excel type="csv" :data="formattedData" :name="generateReportName('Signup_Report', '.csv')" :sheet-name="'Report'">-->
                        <!--                            <a href="#"-->
                        <!--                               class="export-link">-->
                        <!--                                <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;-->
                        <!--                        </download-excel>-->
                        <!--                        <download-excel :data="formattedData" :name="generateReportName('Signup_Report', '.xls')">-->
                        <!--                            <a href="#" class="export-link text-warning">-->
                        <!--                                <i class="fa fa-file-excel-o"></i> Export to Excel</a>-->
                        <!--                        </download-excel>-->
                    </div>
<!--                    <BarChart :chart-data="reportData" :chart-options='{responsive: true}'/>-->
                    <BarChart
                        :chart-data="reportData"
                        :chart-options="chartOptions"
                    />

                    <p class="text-center mt-2">
                        <b>{{ periodData }}</b>
                    </p>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/inertia-vue';
import BarChart from "../../Shared/BarChart";

export default {
    metaInfo: {title: 'Signup Reports'},
    props: [
        'signupReports', 'totalSignups', 'period'
    ],
    layout: Layout,
    name: 'SignupReport',
    components: {
        BarChart,
        Link,
    },
    mixins: [],
    data: () => ({
        reportData: { labels: [], datasets: [] },
        excelData: {},
        periodData: null,
        chartOptions: {
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: ''
                }
            }
        },
        reportFilter : {
            start_date: '',
            end_date: ''
        },
    }),
    mounted() {
        console.log(this.signupReports)
        this.reportData = this.generateReportDataset(this.signupReports, "");
        this.chartOptions.plugins.title.text = `Signup Reports (${this.totalSignups})`;
        this.periodData =  this.period;
    },

    methods: {
        generateReportDataset(report, label) {
            let reportData = {
                labels: [],
                datasets: [],
            }

            let data = []

            for (const key in report) {
                reportData.labels.push(key);
                data.push(report[key]);
            }

            reportData.datasets.push({
                label: label ?? 'Signup Reports',
                backgroundColor: '#8E50EB',
                data
            })
            return reportData;
        },
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },
        async filterData() {
            try {
                let results = await axios.get(route("admin.reports.sign-up"), {
                    params: {
                        start_date: this.reportFilter.start_date,
                        end_date: this.reportFilter.end_date,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.reportData = this.generateReportDataset(results.data.signupReports, "");
                this.chartOptions.plugins.title.text = `Signup Reports (${results.data.totalSignups})`;
                this.periodData = results.data.period;
            } catch (e) {
                console.log(e);
            }
        },
        async resetFilter() {
            this.reportFilter = {
                start_date: '',
                end_date: ''
            }

            await this.filterData();
        },
    },
    computed: {
    }
}
</script>
